// extracted by mini-css-extract-plugin
module.exports = {"image":"Image_image__H9Hs3","ready":"Image_ready__0JZ6s","loader":"Image_loader__XPK38","show":"Image_show__V01Nb","placeholder":"Image_placeholder__WOGA3"};